// export const URL = "http://localhost:4000"
export const URL = "https://chatapp-y8xn.onrender.com"
// export const URL = "https://signfrom-backend-bwwf.onrender.com"